module.exports = __webpack_public_path__ + "img/document-upload.7a7663cc.svg";